<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <label>Employee Directory</label>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <div class="row align-items-center">
                    <div class="col-auto w-25">
                        <ng-select id="fieldnames-dropdown" [items]="searchBy" bindLabel="FieldNames"
                            bindValue="FieldNames" placeholder="Field Name" [(ngModel)]="selectedFieldName"
                            (change)="onDropdownClear('feildname')">
                        </ng-select>
                    </div>
                    <div class="col-auto w-75">
                        <ng-select id="employees-dropdown" [items]="employees" bindLabel="DisplayLabel"
                            bindValue="EmpCode" placeholder="Employee" [(ngModel)]="selectedEmployeeId"
                            (change)="onDropdown2Change($event)" (input)="onInputChange($event)"
                            (clear)="onDropdownClear('Employeename')">
                        </ng-select>
                    </div>
                </div>
                <div class="invalid-feedback">
                    Please enter employee detail !
                </div>
            </div>
        </div>
        <div class="container mt-4" style="width: 100%; overflow: auto;" *ngIf=" empMasterId > 0 && showDetail">
            <div class="card">
                <div class="card-body d-flex align-items-start">
                    <!-- <div class="me-4 d-flex flex-column align-items-center">
                        <img src="{{ this.selectedEmployee.PhotoLink || '../../../../assets/Person.png' }}"
                            alt="Employee Photo" class="img-fluid rounded"
                            style="width: 150px; height: 150px; object-fit: cover;" />
                        <h3 class="form-label text-label-dark mt-2" style="text-align: center;">
                            #{{ selectedEmployee.EmpCode }}
                        </h3>
                    </div> -->
                    <div class="me-4 d-flex flex-column align-items-center">
                        <div *ngIf="this.selectedEmployee.PhotoLink && this.selectedEmployee.PhotoLink !== ''">
                            <img [src]="this.selectedEmployee.PhotoLink" alt="Employee Photo"
                                style="width: 150px; height: 150px;" class="userImage" />
                        </div>
                        <div *ngIf="!this.selectedEmployee.PhotoLink || this.selectedEmployee.PhotoLink === ''"
                            class="initial-image-big1">
                            <div class="image">
                                {{ common.getInitial(this.selectedEmployee.EmpName) }}
                            </div>
                        </div>
                        <h3 class="form-label text-label-dark mt-2" style="text-align: center;">
                            #{{ selectedEmployee.EmpCode }}
                        </h3>
                    </div>
                    <div class="w-100">
                        <div class="row g-3">
                            <br>
                            <div class="row m-1">
                                <div class="col px-1">
                                    <h3 class="d-inline fsize">{{ selectedEmployee.EmpName }}</h3><br>
                                    <span class="text-muted text-label-light">{{ selectedEmployee.DesignationName
                                        }}</span><br>
                                    <span class="text-muted text-label-light"
                                        [ngClass]="{'success': common.ToLowerCase(selectedEmployee.EmpConfirmedStatus) == 'confirmed'}">{{
                                        selectedEmployee.EmpConfirmedStatus }}
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <h3 class="form-label text-label-dark"
                                        [ngClass]="{'text-success': common.ToLowerCase(selectedEmployee.Status) == 'working', 'text-danger':common.ToLowerCase(selectedEmployee.Status) != 'working'}">
                                        {{ selectedEmployee.Status }}</h3>
                                </div>
                            </div>
                            <div class="row m-1">
                                <!-- <div class="col-md-6 px-1">
                                    <label class="form-label text-label-dark">Birth Date:</label> <label
                                        class="form-label text-label-light1">&nbsp;{{
                                        selectedEmployee.BirthDate }}</label>
                                </div> -->
                                <div class="col-md-6 px-1">
                                    <label class="form-label text-label-dark"> Joining Date: </label> <label
                                        class="form-label text-label-light1">&nbsp; {{
                                        selectedEmployee.JoiningDate }}</label>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md-6 px-1">
                                    <label class="form-label text-label-dark"> Mobile No: </label> <label
                                        class="form-label text-label-light1">&nbsp; {{
                                        selectedEmployee.MobileNo || 'N/A' }}</label>
                                </div>
                                <div class="col-md-6 px-1">
                                    <label class="form-label text-label-dark"> Reporting Manager: </label> <label
                                        class="form-label text-label-light1">&nbsp;{{
                                        selectedEmployee.ReportingManager }}</label>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md-6 px-1">
                                    <label class="form-label text-label-dark"> Grade: </label> <label
                                        class="form-label text-label-light1">&nbsp;{{
                                        selectedEmployee.GradeName }}</label>
                                </div>
                                <div class="col-md-6 px-1">
                                    <label class="form-label text-label-dark">Department: </label> <label
                                        class="form-label text-label-light1">&nbsp;{{
                                        selectedEmployee.DepartmentName }}</label>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-2 px-1">
                                            <label class="form-label text-label-dark">Branch: </label>
                                        </div>
                                        <div class="col-md-10 px-2">
                                            <label class="form-label text-label-light1">&nbsp; {{
                                                selectedEmployee.BranchName }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6  " *ngIf="common.ToLowerCase(selectedEmployee.EmpType) == 'front'">
                                    <div class="row">
                                        <div class="col-md-2 px-1">
                                            <label class="form-label text-label-dark"> Client: </label>
                                        </div>
                                        <div class="col-md-10 px-1">
                                            <label class="form-label text-label-light1">&nbsp;{{
                                                selectedEmployee.ClientName }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 " *ngIf="common.ToLowerCase(selectedEmployee.EmpType) == 'front'">
                                    <div class="row">
                                        <div class="col-md-2 px-1">
                                            <label class="form-label text-label-dark"> Site: </label>
                                        </div>
                                        <div class="col-md-10 px-1">
                                            <label class="form-label text-label-light1">&nbsp;{{
                                                selectedEmployee.SiteName
                                                }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-1">
                                <div class="col-md-8 ">
                                    <div class="row">
                                        <div class="col-md-2 px-1">
                                            <label class="form-label text-label-dark"> Email: </label>
                                        </div>
                                        <div class="col-md-10 px-1">
                                            <span class="form-label text-label-light1">&nbsp; {{ selectedEmployee.Email
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer m-2">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary me-1" ngbTooltip="Cancel" container="body"
                    placement="top" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>